import { render, staticRenderFns } from "./GrantDialog.vue?vue&type=template&id=26b87a6b&scoped=true"
import script from "./GrantDialog.vue?vue&type=script&lang=js"
export * from "./GrantDialog.vue?vue&type=script&lang=js"
import style0 from "./GrantDialog.vue?vue&type=style&index=0&id=26b87a6b&prod&scoped=true&lang=css"
import style1 from "./GrantDialog.vue?vue&type=style&index=1&id=26b87a6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b87a6b",
  null
  
)

export default component.exports